<!-- Material Costs -->
    <div class="panel-header-container" [formGroup]="materialCostsFormGroup">
        <div class="panel-header-row" formGroupName="materialCostsHeader">

            <button mat-icon-button (click)="isMaterialCostsExpanded = !isMaterialCostsExpanded" class="button-expand-collapse">
                <mat-icon class="icon-expand-collapse">
                    {{isMaterialCostsExpanded ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>
            <table class="full-width" >
                <tr class="custom-table-row">
                    <td class="estimate-table-column width-190">{{ 'MATERIAL_COSTS' | translate}}</td>
                    <td class="estimate-table-column width-110">
                        {{ materialCostsFormGroup.controls.materialCostsHeader.controls.cost.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-70">
                        {{ materialCostsFormGroup.controls.materialCostsHeader.controls.tdcPercentage.value | decimalPrecision }}%
                    </td>
                    <td class="estimate-table-column width-70">
                        <ng-container *ngIf=" isMarkUpSelected; else materialCostsGrossgrossMarginPercentage">
                            {{ materialCostsFormGroup.controls.materialCostsHeader.controls.markUpPercentage.value | decimalPrecision }}%
                        </ng-container>
                        <ng-template #materialCostsGrossgrossMarginPercentage>
                            {{ materialCostsFormGroup.controls.materialCostsHeader.controls.grossMarginPercentage.value | decimalPrecision }}%
                        </ng-template>
                    </td>
                    <td class="estimate-table-column width-210 padding-gm">
                        {{ materialCostsFormGroup.controls.materialCostsHeader.controls.grossMargin.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-110">
                        {{ materialCostsFormGroup.controls.materialCostsHeader.controls.sellPrice.value | multilingualCurrency }}
                    </td>
                </tr>
            </table>
        </div>

        <div *ngIf="isMaterialCostsExpanded" >
            
            <app-sol-estimate-table-material-type
                [isMaterialExpanded]="isSiemensMaterialExpanded"
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [sectionLabel]="'SIEMENS_MATERIAL'"
                [materialRowForm]="siemensMaterialFormGroup"
                [isCollaborativeNotEdit]="isCollaborativeNotEdit"
            ></app-sol-estimate-table-material-type>

            <app-sol-estimate-table-material-type
                [isMaterialExpanded]="isOutsideMaterialExpanded"
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [sectionLabel]="'OUTSIDE_MATERIAL'"
                [materialRowForm]="outsideMaterialFormGroup"
                [isCollaborativeNotEdit]="isCollaborativeNotEdit"
            ></app-sol-estimate-table-material-type>
            <app-sol-estimate-table-material-type
                [isMaterialExpanded]="isMechanicalMaterialExpanded"
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [sectionLabel]="'MECHANICAL_MATERIAL'"
                [materialRowForm]="mechanicalMaterialFormGroup"
                [isCollaborativeNotEdit]="isCollaborativeNotEdit"
            ></app-sol-estimate-table-material-type>
            <app-sol-estimate-table-material-type
                [isMaterialExpanded]="isElectricalMaterialExpanded"
                [isCollaborativeNotEdit]="isCollaborativeNotEdit"
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [sectionLabel]="'ELECTRICAL_MATERIAL'"
                [materialRowForm]="electricalMaterialFormGroup"
                [isCollaborativeNotEdit]="isCollaborativeNotEdit"
            ></app-sol-estimate-table-material-type>

        </div>
    </div>